import { useState, useEffect } from 'react';
import { getPublicPage } from '../api/api';

function parseSections(raw) {
  return raw
    .map(s => ({
      ...s,
      content: typeof s.content === 'string'
        ? (() => { try { return JSON.parse(s.content); } catch { return {}; } })()
        : (s.content || {}),
    }))
    .filter(s => String(s.actif) !== '0');
}

export default function useCmsPage(slug) {
  const cacheKey = `cms_${slug}`;

  // Initialisation immédiate depuis localStorage → pas de flash au retour sur une page
  const [sections, setSections] = useState(() => {
    try {
      const c = localStorage.getItem(cacheKey);
      return c ? JSON.parse(c) : [];
    } catch { return []; }
  });
  const [page, setPage]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError(null);

    getPublicPage(slug)
      .then(data => {
        const pageData = data?.data || data;
        setPage(pageData || null);
        const parsed = parseSections(pageData?.sections || []);
        setSections(parsed);
        // Mise en cache — visible immédiatement à la prochaine navigation
        try { localStorage.setItem(cacheKey, JSON.stringify(parsed)); } catch {}
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, [slug]);

  return { sections, page, loading, error };
}
